import './SearchInput.scss';

import React, { useState, useEffect, MutableRefObject } from 'react';
import classNames from 'classnames';
import { Keys } from '../../helpers/constants';

export interface SearchInputProps {
  placeholder?: string;
  searchFilter?: string;
  inputRef?: MutableRefObject<HTMLInputElement>;
  className?: string;
  disabled?: boolean;
  width?: string | number;

  /**
   * Raised when the search input has changed and the "Enter/Return" key is pressed or
   * the spyglass icon is clicked.
   *
   * @param term The changed search term
   */
  onSearchChange: (term: string) => void;

  /**
   * Raised when the 'X' clear icon is clicked.
   */
  onSearchClear?: VoidFunction;

  onSearchFocus?: () => void;
}

// todo - move this to src/components
export default function SearchInput(props: SearchInputProps) {
  const [search, setSearch] = useState(props.searchFilter);

  useEffect(() => {
    setSearch(props.searchFilter);
  }, [props.searchFilter]);

  const searchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === Keys.Enter) {
      props.onSearchChange(search);
      (e.target as HTMLInputElement).blur();
    }
  };

  return (
    <div className={classNames('ui icon input search-input', props.className)}>
      <input
        type="text"
        placeholder={props.placeholder}
        value={search || ''}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={searchKeyDown}
        ref={props.inputRef}
        disabled={props.disabled || false}
        style={props.width && { width: props.width }}
        onFocus={props.onSearchFocus}
      />
      {props.disabled ? (
        <i aria-hidden="true" className="search link icon" />
      ) : !props.searchFilter || props.searchFilter !== search ? (
        <i aria-hidden="true" className="search link icon" onClick={() => props.onSearchChange(search)} />
      ) : (
        <i
          aria-hidden="true"
          className="x icon link"
          onClick={() => {
            setSearch(null);
            // maintain the existing functionality.
            props.onSearchChange('');
            // raise the new event
            props.onSearchClear?.();
          }}
        />
      )}
    </div>
  );
}
